import { isMobile } from "react-device-detect";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import HomePage from "./pages/home";

import headerSvg from "./assets/svgs/Oval.svg";
import footerSvg from "./assets/svgs/FooterDesktop.svg";
import matach from "./assets/svgs/matach.svg";
import grapes from "./assets/svgs/grapes.svg";
import computer from "./assets/svgs/computer.svg";
import book from "./assets/svgs/Book.svg";
import line from "./assets/svgs/line.svg";
import bubbles from "./assets/svgs/bubbles.svg";
import bubbletTiangle from "./assets/svgs/bubbletTiangle.svg";
import star from "./assets/svgs/star.svg";
import dotsLine from "./assets/svgs/dotsLine.svg";
import footerMobile from "./assets/svgs/Mobile Footer.svg";
import headerMobile from "./assets/svgs/headerMobile.svg";
import matachMobile from "./assets/svgs/matachMobile.svg";
import grapesMobile from "./assets/svgs/grapesMobile.svg";

import "./App.css";

function App() {
  return (
    <>
      <header>
        {isMobile ? (
          <>
            <img
              src={headerMobile}
              alt="headerMobileSvg"
              className="headerSvg"
            />
            <img
              src={matachMobile}
              alt="matachMobileSvg"
              className="matachMobile-svg"
            />
            <img
              src={grapesMobile}
              alt="grapesMobileSvg"
              className="grapesMobile-svg"
            />
          </>
        ) : (
          <img src={headerSvg} alt="headerSvg" className="headerSvg" />
        )}
      </header>
      <div className={isMobile ? "home-page-Mobile" : "home-page-wrapper"}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/1" element={<Navigate to="/" />} />
            <Route path="/:type" element={<HomePage />} />
          </Routes>
        </BrowserRouter>

        {!isMobile && (
          <>
            <img src={grapes} alt={"grapesSvg"} className="grapes-svg" />
            <img
              src={matach}
              alt={"matachSvg"}
              className={isMobile ? "matach-svg-mobile" : "matach-svg"}
            />
            <img src={computer} alt={"computerSvg"} className="computer-svg" />
            <img src={book} alt={"bookSvg"} className="book-svg" />
            <img src={line} alt={"lineSvg"} className="line-svg" />
            <img src={bubbles} alt="bubblesSvg" className="bubbles-svg" />
            <img
              src={bubbletTiangle}
              alt="bubbletTiangleSvg"
              className="bubbletTiangle-svg"
            />
            <img src={star} alt="starSvg" className="star-svg" />
            <img src={dotsLine} alt="dotsLineSvg" className="dotsLine-svg" />
          </>
        )}
      </div>
      <footer>
        {isMobile ? (
          <img src={footerMobile} alt="footerMobileSvg" className="footerSvg" />
        ) : (
          <img src={footerSvg} alt="footerSvg" className="footerSvg" />
        )}
      </footer>
    </>
  );
}

export default App;
